
import Bar from './Bar.vue'

export default {
  components: {
    Bar,
  },
  props: {
    foregroundColor: {
      type: String,
      default: '#111111',
    },
    done: {
      type: Number,
      required: true,
    },
    ongoing: {
      type: Number,
      default: 0,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasOngoingProgressBar() {
      return this.ongoing > 0 && this.done < 100
    },
    fillOngoing() {
      if (this.hasOngoingProgressBar) {
        return this.vertical
          ? { height: `${this.ongoing}%` }
          : { width: `${this.ongoing}%` }
      }

      return null
    },
  },
}
